import { useUserStore } from '@/stores/user'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...routes, // 静态路由优先
    {
      path: '',
      component: () => import('@/components/layout/system/IndexLayout.vue'),
      children: [
        {
          path: '/:pathArr(.*)*',
          component: () => import('@/components/layout/system/DynamicLayout.vue') // 专门处理动态加载的组件
        }
      ]
    }
  ]
})

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 进度条速度
  showSpinner: false // 隐藏加载小圆圈
})
const whiteList = ['/login', '/401', '/404', '/register']
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  console.log('router-index.ts beforeEach', to, from, to.name, from.name)
  if (to.matched.length == 0) {
    next(`/404`)
    return
  }
  if (whiteList.includes(to.path)) {
    //白名单页面
    next()
    return
  }
  const canAccess = to.meta.canAccess ? to.meta.canAccess : () => true
  const userStore = useUserStore()
  if (userStore.sessionToken.token) {
    if (to.fullPath === from.fullPath || (from.path === '/' && from.matched.length == 0)) {
      console.log('refresh page  || / path')
      //after login exchange info
      await userStore.exchangeLoginInfo()
    }
    if (canAccess()) {
      next()
    } else {
      next(`/401?redirect=${to.path}`)
    }
  } else {
    if (canAccess()) {
      next()
    } else {
      //需要token但是没有，则跳转登录页
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束进度条
})

export default router
